import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-white/50 font-mono">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
